<template>
  <base-block-epi
    class="teaser-collection-block"
    :size="size"
    :layout-type="layoutType"
    :url="primaryUrl"
    @simulateClick="simulateClickOnLink"
  >
    <template #media>
      <teaser-collection-block-images
        :image-one="imageOne"
        :image-two="imageTwo"
        :image-three="imageThree"
        :image-four="imageFour"
        :size="size"
        :is-highlight="isHighlight"
      />
    </template>
    <template #content>
      <div
        class="teaser-collection-block__content__prefix"
        v-text="prefix"
      />
      <h3
        v-edit="'Title'"
        class="teaser-collection-block__content__title"
      >
        <component
          :is="(!buttonLabel || $root.isSmallViewport) ? 'a' : 'span'"
          :ref="(!buttonLabel || $root.isSmallViewport) ? 'teaserCollectionBlockLink' : 'notUsed'"
          :href="(!buttonLabel || $root.isSmallViewport) ? primaryUrl : null"
          :aria-label="(!buttonLabel || $root.isSmallViewport) ? title : null"
          class="teaser-collection-block__content__link"
        >
          {{ title }}
        </component>
      </h3>
      <div
        v-if="($root.isMediumViewport && isHighlight) || ($root.isLargeViewport && isSize.full) || isEditable"
        v-edit="'Preamble'"
        class="teaser-collection-block__content__preamble"
        v-text="preamble"
      />
      <a
        v-if="(buttonLabel && ($root.isMediumViewport || $root.isLargeViewport) && isSize.full) || isEditable"
        ref="teaserCollectionBlockLink"
        v-edit="'ButtonLabel'"
        :href="primaryUrl"
        class="button--secondary teaser-collection-block__content__button"
        :class="$root.isMediumViewport || $root.isSmallViewport ? 'button--40' : 'button--48'"
        @click.stop
        v-text="buttonLabel"
      />
      <epi-property
        v-if="buttonLabel"
        id="primaryUrl"
        text="Länk till sida"
      />
    </template>
  </base-block-epi>
</template>

<script>
import BaseBlockEpi, { layoutTypes } from '@/vue/components/BaseBlockComponent/baseBlockComponent'
import TeaserCollectionBlockImages from './teaserCollectionBlockImages.vue'
export default {
  name: 'TeaserCollectionBlock',
  components: {
    BaseBlockEpi,
    TeaserCollectionBlockImages
  },
  props: {
    blockSize: {
      type: String,
      default: 'quarter',
      validator (value) {
        return ['full', 'half', 'third', 'quarter'].includes(value)
      }
    },
    primaryUrl: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    preamble: {
      type: String,
      default: ''
    },
    buttonLabel: {
      type: String,
      default: null
    },
    imageOne: {
      type: Object,
      default: () => {}
    },
    imageTwo: {
      type: Object,
      default: () => {}
    },
    imageThree: {
      type: Object,
      default: () => {}
    },
    imageFour: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    size () {
      return this.isEditable ? 'full' : this.blockSize
    },
    primaryImage () {
      return this.imageUrls.length ? this.imageUrls[0]: ''
    },
    secondaryImages () {
      let secondary =  this.imageUrls.length > 1 ? this.imageUrls.slice(1) : []
      for (let i = secondary.length; i < 3; i++) {
        secondary.push('')
      }

      return secondary
    },
    isSize () {
      return {
        [this.size]: true
      }
    },
    isHighlight () {
      return ['full', 'half'].includes(this.size)
    },
    layoutType () {
      switch(this.$root.currentSize) {
        case 'sm':
        case 'xs':
        case 'xxs':
          return this.isHighlight ? layoutTypes.mediaTop : layoutTypes.mediaLeft
        case 'md':
          return this.isHighlight ? layoutTypes.mediaLeft : layoutTypes.mediaTop
        case 'lg':
        case 'xl':
          return this.isSize.full ? layoutTypes.mediaLeft : layoutTypes.mediaTop
      }

      return layoutTypes.mediaTop
    }
  },
  methods: {
    simulateClickOnLink () {
      this.$refs.teaserCollectionBlockLink.click()
    }
  }
}
</script>


<style lang="scss">
.teaser-collection-block {
  $this: &;

  .button--teaserid-edit.button--editbutton {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
  }

  .base-block-epi--media-left &__media {
    margin-right: -0.5rem;
  }

  .base-block-epi__content {
    @at-root {
      .base-block-epi--media-top#{&} {
        margin-top: -0.5rem;
      }
    }

    &__padding {
      margin: auto;

      @include media-breakpoint-up(md) {
        padding: 1.5rem 13rem;
      }

      #{$this}__content__prefix {
        @include font(hand, 1, "normal");

        color: $color-red;
      }

      #{$this}__content__link {
        color: $color-black;

        &:hover,
        &:active {
          color: $color-black;
        }
      }

      #{$this}__content__title {
        $title: &;

        margin: 0;
        text-transform: uppercase;
      }

      #{$this}__content__preamble {
        @include font(text, 3, "light");

        margin: 1rem 0 0;

        @include media-breakpoint-up(lg) {
          @include font(text, 4, "light");

          margin: 1.5rem 0 0;
        }
      }

      #{$this}__content__button {
        margin-top: 2rem;

        @include media-breakpoint-up(lg) {
          margin-top: 2.5rem;
        }
      }
    }
  }

  $contentPadding: '.base-block-epi__content .base-block-epi__content__padding';

  // sm & md highlight padding
  &.base-block-epi.base-block-epi--highlight #{$contentPadding} {
    @include media-breakpoint-up(md) {
      padding: 3.5rem 3rem;
    }
  }

  // lg padding
  @include media-breakpoint-up(lg) {
    &.base-block-epi.base-block-epi--quarter #{$contentPadding},
    &.base-block-epi.base-block-epi--third #{$contentPadding} {
      padding: 2.5rem 1rem;
    }

    &.base-block-epi.base-block-epi--half #{$contentPadding} {
      padding: 2.75rem 2rem;
    }
  }

  // xl padding
  @include media-breakpoint-up(xl) {
    &.base-block-epi.base-block-epi--half #{$contentPadding} {
      padding: 2.5rem;
    }
  }

  @include media-breakpoint-down(sm) {
    &.base-block-epi.base-block-epi--highlight .base-block-epi__inner-wrapper {
      min-height: 20rem;

      .base-block-epi__media-lg {
        height: 20rem;
      }
    }
  }

  body:not([ie11]) &.base-block-epi--media-top .base-block-epi__media-lg {
    @include media-breakpoint-up(md) {
      flex: 0%; // Fix for safari
    }
  }
}
</style>
